module.exports = __webpack_public_path__ + "media/video-thumbnails/2-e3abd921.gif";